document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('[data-video]');
    items.forEach((item) => {
        item.addEventListener('click', function (event) {
            event.preventDefault();
            console.log(this.parentNode);
            const newItem = document.createElement('iframe');
            newItem.setAttribute('src', this.dataset.video  + '?autoplay=1');
            newItem.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' );
            newItem.classList.add('w-full');
            newItem.classList.add('aspect-video');
            //newItem.innerHTML = '<iframe src="https://www.youtube.com/embed/' + this.dataset.video  + '&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

            this.parentNode.replaceChild(newItem, this);
        });
    });
});
